<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
<!--      <el-button type="primary" @click="addRecharge()">充值</el-button>-->
      <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="输入姓名" style="width: 250px"></el-input>
<!--      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels-->
<!--                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"-->
<!--                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">-->
<!--      </el-date-picker>-->
      <el-date-picker v-fixZoom :clearable="false" v-model="value1" type="month" placeholder="选择月" @change="changeTime"></el-date-picker>
      <el-button type="success" @click="searchBtn">查询</el-button>
    </div>
    <div style="height: 120px;font-size: 20px;margin-left: 20px;margin-right: 20px;">
      <el-card class="box-card my-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 16px;color: #999999">养老院月度充值消费统计</span>
        </div>
        <div style="height: 20px">
          <div style="float: left;min-width: 220px"><span>月份：</span><span style="font-size: 26px;color: #E6A23C">{{ elderlyFinanceMonth.month }}</span></div>
          <div style="float: left;min-width: 280px"><span>当月充值总额：</span><span style="font-size: 26px;color: #67C23A">{{ elderlyFinanceMonth.recharge_amount}}</span></div>
          <div style="float: left;min-width: 280px"><span>当月消费总额：</span><span style="font-size: 26px;color: #409EFF">{{ elderlyFinanceMonth.consumption_amount }}</span></div>
        </div>
      </el-card>
    </div>
    <div style="max-height: calc(100% - 240px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="elderly_name"
          label="老人姓名"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="变动类型"
          width="90"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.change_type === 1">充值</span>
            <span v-if="scope.row.change_type === 2">消费</span>
            <span v-if="scope.row.change_type === 3">退款</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="change_amount"
          label="变动金额"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="before_amount"
          label="变动前余额"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="after_amount"
          label="变动后余额"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="change_time"
          label="变动时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="change_remark"
          label="变动备注"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="openCheck(scope.row)">账单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{addEditTitle}}</span>
        <div class="line-title"></div>
      </div>
      <finance-order :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></finance-order>
    </el-dialog>
    <el-dialog :visible.sync="openShow" v-if="openShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{rowData.elderly_name}}</span>
        <div class="line-title"></div>
      </div>
      <div style="margin: 0 20px">
<!--        <el-date-picker v-fixZoom size="small" :clearable="false" v-model="sendDate1" type="daterange" unlink-panels-->
<!--                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"-->
<!--                        value-format="yyyy-MM-dd" style="margin-right: 10px; width: 300px">-->
<!--        </el-date-picker>-->
        <el-date-picker v-fixZoom :clearable="false" v-model="value2" type="month" placeholder="选择月" @change="changeTime2"></el-date-picker>
        <el-button size="small" type="success" @click="openCheckData">查询</el-button>
      </div>
      <div style="margin: 20px">
        <el-card class="box-card my-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;color: #999999">个人月度充值消费统计</span>
          </div>
          <div style="height: 20px">
            <el-row>
              <el-col :span="6">
                <span>月份：</span><span style="font-size: 24px;color: #E6A23C">{{ elderlyFinanceMonth1.month }}</span>
              </el-col>
              <el-col :span="9">
                <span>当月充值总额：</span><span style="font-size: 24px;color: #67C23A">{{ elderlyFinanceMonth1.recharge_amount}}</span>
              </el-col>
              <el-col :span="9">
                <span style="font-size: 24px;color: #409EFF">{{ elderlyFinanceMonth1.consumption_amount }}</span>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div style="height: 10px"></div>
    </el-dialog>
  </div>
</template>

<script>
import {queryelderlyfinancebill, queryelderlyfinanceorder, queryelderlyfinancestatistics} from '../../api/yanglaoyuan'
import financeOrder from './components/financeOrder'
import {queryorg} from '../../api/organizer'

export default {
  name: 'financeStatistics',
  components: {financeOrder},
  data () {
    return {
      value1: '',
      elderlyFinanceMonth: {},
      searchName: '',
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      entityId: 0,
      addEditShow: false,
      addEditTitle: '',
      addEditObj: {
        isAdd: true,
        change_type: 1, // 1、充值
        row: '',
        orgArr1: [],
        orgArr2: []
      },
      orgArr: [],
      value2: '',
      sendDate1: [],
      openShow: false,
      elderlyFinanceMonth1: '',
      rowData: ''
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const end = new Date()
    const start = new Date()
    start.setDate(1)
    this.value1 = start
    this.sendDate = [start.format('yyyy-MM-dd'), end.format('yyyy-MM-dd')]
    this.getTimeObj()
    this.getOrgData()
    this.queryDataTable()
    this.getMonthFinance()
  },
  methods: {
    changeTime (val) {
      let aa = this.value1.format('yyyy-MM-dd').split('-')
      this.sendDate = [this.value1.format('yyyy-MM-dd'), this.getLastDay(aa[0], aa[1])]
    },
    changeTime2 (val) {
      let aa = this.value2.format('yyyy-MM-dd').split('-')
      this.sendDate1 = [this.value2.format('yyyy-MM-dd'), this.getLastDay(aa[0], aa[1])]
    },
    getLastDay (year, month) {
      let lastDate = new Date(year, month, 0).getDate() // 获取当月最后一日
      return [year, month, lastDate].join('-')
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    // 组织
    getOrgData () {
      this.addEditObj.orgArr1 = []
      this.addEditObj.orgArr2 = []
      queryorg().then(res => {
        this.orgArr = this.clone(res.data.org)
        for (let i = 0; i < this.orgArr.length; i++) {
          if (this.orgArr[i].org_type === 1) {
            this.addEditObj.orgArr1.push(this.orgArr[i])
          }
          if (this.orgArr[i].org_type === 2) {
            this.addEditObj.orgArr2.push(this.orgArr[i])
          }
        }
      }).catch(() => {
      })
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId,
        epid: 0,
        ep_name: this.searchName,
        change_time_from: this.sendDate[0] + ' 00:00:00',
        change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinanceorder(params, data).then(res => {
        this.tableData = res.data.elderlyFinanceOrder
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    // 月账单
    getMonthFinance () {
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        change_time_from: this.sendDate[0] + ' 00:00:00',
        change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinancestatistics(data).then(res => {
        this.elderlyFinanceMonth = res.data.elderlyFinanceMonth
      }).catch(() => {})
    },
    openCheck (row) {
      this.rowData = row
      this.sendDate1 = this.sendDate
      this.value2 = this.value1
      this.openCheckData()
    },
    openCheckData () {
      let data = {
        eid: this.entityId,
        epid: this.rowData.epid,
        change_time_from: this.sendDate1[0] + ' 00:00:00',
        change_time_to: this.sendDate1[1] + ' 23:59:59'
      }
      queryelderlyfinancebill(data).then(res => {
        this.elderlyFinanceMonth1 = res.data.elderlyFinanceMonth
        this.openShow = true
      }).catch(() => {})
    },
    searchBtn () {
      this.getMonthFinance()
      this.queryDataTable()
    },
    updateTable () {
      this.queryDataTable()
    },
    addRecharge () {
      this.addEditTitle = '充值'
      this.addEditObj.change_type = 1
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/financeStatistics.vue